import { render, staticRenderFns } from "./ModalSelecaoTipoAssinatura.vue?vue&type=template&id=4dd5419d"
import script from "./ModalSelecaoTipoAssinatura.vue?vue&type=script&lang=js"
export * from "./ModalSelecaoTipoAssinatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports